import { useWatch } from "react-hook-form";
import { RefundFormValues } from "../RefundSchema";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { formatCents } from "utils/formatCurrency";
import CurrencyInput from "components/Forms/CurrencyInput";
import { useMemo } from "react";

interface RefundAllocationRowProps {
  index: number;
}

export default function RefundAllocationRow({
  index,
}: RefundAllocationRowProps) {
  const {
    memo = "",
    payment_amount = 0,
    payment_amount_allocated = 0,
    payment_amount_refunded = 0,
    previous_amount = 0,
  } = useWatch<RefundFormValues, `allocations.${number}`>({
    name: `allocations.${index}`,
  }) ?? {};

  const amountOverpaid = useMemo(() => {
    // get the total amount that was paid
    const paymentAmount = payment_amount;

    // get the amount allocated towards charges
    const paymentAmountAllocated = payment_amount_allocated;

    // get the amount that has already been refunded (excluding this refund)
    const paymentAmountRefunded = payment_amount_refunded - previous_amount;

    // calculate the amount that can be refunded
    return paymentAmount - paymentAmountAllocated - paymentAmountRefunded;
  }, [
    payment_amount,
    payment_amount_allocated,
    payment_amount_refunded,
    previous_amount,
  ]);

  return (
    <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
      <TableCell component="th" scope="row">
        {memo}
      </TableCell>
      <TableCell align="right">{formatCents(payment_amount)}</TableCell>
      <TableCell align="right">
        {formatCents(payment_amount_allocated)}
      </TableCell>
      <TableCell align="right">
        {formatCents(payment_amount_refunded)}
      </TableCell>
      <TableCell align="right">{formatCents(amountOverpaid)}</TableCell>
      <TableCell align="left">
        <CurrencyInput name={`allocations.${index}.amount`} label={""} />
      </TableCell>
    </TableRow>
  );
}
